import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'How do I receive the package after purchasing?',
  a: 'You will receive immediate access to all the material so you can start using it right away — no waiting, no complicated steps.'
}, {
  q: 'What level of BJJ instructor is this designed for?',
  a: 'The system is designed for instructors who teach beginner and developing students — from their very first class through to the intermediate level. It works whether you have been teaching for months or for years and simply want to stop planning from scratch every week.'
}, {
  q: 'Does this work for BJJ instructors in any country?',
  a: 'Yes. The system is in English and is designed to work in any academy, garage gym, school program or training environment — regardless of country or affiliation.'
}, {
  q: 'Can I edit the material?',
  a: 'The material is delivered in ready-to-use PDF format. It is designed so you do not need to edit it — you open it, read it and teach it. If you need to adapt it to your specific context, the content is clear and structured enough to use as a strong foundation.'
}, {
  q: 'What currency will I pay in?',
  a: 'The price is displayed in USD, but the system automatically detects your country and adapts the payment to your local currency.'
}, {
  q: 'What if it doesn’t work for me?',
  a: 'You have 7 days to explore everything. If it is not what you need, we will refund 100% of your money. No questions asked.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-cream-beige" data-id="element-99" data-mp="wz7af2hx55ac">
      <div className="max-w-3xl mx-auto" data-id="element-100" data-mp="wvt63opp2m09">
        <div className="text-center mb-16" data-id="element-101" data-mp="iy4oqquu5wzy">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-navy-deep" data-id="element-102" data-mp="j0hcjkn9z1kx">
            ❓ Frequently Asked Questions
          </h2>
        </div>
        <div className="space-y-4" data-id="element-103" data-mp="2pmwybu4tulal">
          {faqs.map((faq, index) => <div key={faq.q} className="bg-cream-card border border-gold-light rounded-xl overflow-hidden shadow-sm" data-id="element-104" data-mp="2kw6p25ta5yam" data-mpi={index}>
              <button type="button" className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-105" data-mp="2fx3mqt4oq66c">
                <span className="font-bold text-lg text-navy-deep pr-8" data-id="element-106" data-mp="2ymjw85ycl8yw">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`text-gold transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-107" data-mp="2ukydi3z4u0gs" />
              </button>
              <AnimatePresence initial={false} data-id="element-108" data-mp="1j8xhc3zxv9r0">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-109" data-mp="3us3foqu376xc">
                    <div className="px-6 pb-5 text-warmgray border-t border-gold-light pt-4" data-id="element-110" data-mp="hfa4ex8cwf4h">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}